import TourLandingTemplate from './TourLandingTemplate';
import stopPhotos from './stopPhotos';

function TourGeorgia() {
  return (
    <TourLandingTemplate
      location="East Coast Book Launch Celebration"
      date="Atlanta, GA - June 1, 2026"
      photo={stopPhotos['east-coast-launch']}
      photoAlt="East Coast Book Launch Celebration in Atlanta, GA"
      flickrUrl="https://www.flickr.com/photos/shawnyork/albums/72177720333976100/"
    />
  );
}

export default TourGeorgia;
